<template>
  <div class="index" :style="{ minHeight: minHeight }">
    <van-sticky>
      <van-nav-bar :placeholder="true">
        <template slot="title">
          <div class="toggle-buttons">
            <div
              :class="[
                'button',
                { selected: selectedButton === 'left' },
                'left-button',
              ]"
              @click="selectButton('left')"
            >
              按时间查看
            </div>
            <div
              :class="[
                'button',
                { selected: selectedButton === 'right' },
                'right-button',
              ]"
              @click="selectButton('right')"
            >
              按患者查看
            </div>
          </div>
        </template>
      </van-nav-bar>
    </van-sticky>

    <van-search
      shape="round"
      background="#F6F6F6"
      v-model="searchValue"
      @search="searchOk"
      @clear="
        () => {
          this.list = [];
          this.pageNo = 1;
          this.getList();
        }
      "
      :placeholder="
        selectedButton === 'left'
          ? '输入医学公式关键词进行搜索'
          : '输入患者昵称关键字搜索'
      "
    />

    <div v-if="list.length !== 0 && $store.state.memberIdDocument">
      <!--按时间查看-->
      <div v-if="selectedButton === 'left'">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="getList"
        >
          <van-collapse
            accordion
            class="dym_collapse"
            v-model="activeName"
            v-for="item in list"
            :key="item.id"
            @change="change1(item.id)"
          >
            <van-collapse-item :name="item.id">
              <div slot="title">
                <div class="swipe_title">
                  {{ item.chineseName }}
                  <van-icon
                    v-if="item.id == activeName"
                    name="arrow-up"
                    size="14px"
                    style="margin-left:3px;"
                  />
                  <van-icon
                    v-if="item.id !== activeName"
                    name="arrow-down"
                    size="14px"
                    style="margin-left:3px;"
                  />
                </div>
                <div class=" swipe_title_sub ">
                  <span
                    >最近使用时间： {{ dateType(item.createdTime, 0) }}</span
                  >
                  <span
                    style="margin-right:-20px;font-size:14px;color:rgba(25, 155, 251, 1);"
                    v-if="item.id == activeName"
                    @click.stop="goNewBtn(item)"
                  >
                    <van-icon
                      color="rgba(25, 155, 251, 1)"
                      name="add-o"
                      size="14px"
                      style="margin-right:3px;"
                    />新增</span
                  >
                </div>
              </div>
              <div>
                <div
                  v-for="detail in detailList"
                  :key="detail.id"
                  class="detail"
                  @click="logBtn(detail)"
                >
                  <div>结果：{{ detail.result.DisplayResults }}</div>
                  <div class="detail_bottom">
                    <span class="swipe_title_sub">{{
                      dateType(detail.createdTime, 0)
                    }}</span>

                    <van-icon
                      color="#CAC9C9"
                      name="ellipsis"
                      @click.stop="deleteItem(detail)"
                      size="20px"
                      style="margin-right:3px"
                    />
                  </div>
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
        </van-list>
      </div>

      <!--按患者查看-->
      <div v-if="selectedButton === 'right'">
        <div class="card" v-for="(item, index) in list" :key="item.id">
          <div
            style="display: flex;align-items: center;flex: 1"
            @click="goBtn(item)"
          >
            <div
              class="card_man"
              :style="{ borderColor: item.sex === 1 ? '#47A3CC' : '#FF3887' }"
            >
              <img
                style="height: 100%;width: 100%"
                :src="item.sex === 1 ? man : woman"
                alt=""
              />
            </div>
            <div>
              <div class="card_text" style="margin-bottom: 5px">
                <span class="card_name">{{ maskChineseName(item.name) }}</span
                >&nbsp;{{ item.sex === 1 ? "男" : "女"
                }}<span v-if="item.age !== -1">/{{ item.age + "岁" }}</span
                ><span
                  v-if="
                    item.hasOwnProperty('patientNumber') &&
                      item.patientNumber !== ''
                  "
                  >/{{ item.patientNumber }}</span
                >
              </div>
              <div class="card_text" style="display: inline-flex">
                <span style="white-space: nowrap;">{{
                  dateType(item.finishTime, 1)
                }}</span
                >&nbsp;
                <span v-if="isDate(item.finishTime) === 1">
                  <span
                    class="card_title"
                    v-if="item.hasOwnProperty('chineseName')"
                    >完成&nbsp;{{ item.chineseName }}
                  </span>
                </span>
              </div>
            </div>
          </div>

          <van-icon
            style="margin-top: -10px"
            size="0.8rem"
            color="#CAC9C9"
            name="ellipsis"
            @click="toggleMenu(index, $event)"
          />

          <div
            v-if="menuVisible && selectedIndex === index"
            :style="{ top: menuPosition.top + 'px' }"
            class="popup-menu"
            :ref="'popupMenu' + index"
          >
            <div style="margin-bottom: 8px" @click="editItem(index, item)">
              编辑
            </div>
            <div @click="deleteItem(item)">删除</div>
          </div>
        </div>
      </div>
      <div v-if="menuVisible" class="overlay" @click="closeMenu"></div>
    </div>
    <van-empty
      v-if="list.length == 0 && $store.state.memberIdDocument"
      description="暂无内容"
    />
    <div v-if="$store.state.memberIdDocument == ''" class="bottomhhh" @click="login">登录可以查看更多内容</div>

    <medical-form
      :visible="formShow"
      :editData="editForm"
      :member-id="memberId"
      :type="'edit'"
      @close="hideStudent"
    >
    </medical-form>
    <login v-model="loginShow" :title="loginTitle"> </login>
  </div>
</template>
<script>
import { Dialog, Toast } from "vant";
import login from "@/components/login.vue";
import medicalForm from "@/components/medicalForm.vue";
import {
  delMedicalLog_patient,
  delMedicalLog_time,
  getMedicalLog_patient,
  getMedicalLog_time,
  getGroupRecord,
} from "@/service/api";
import moment from "moment/moment";
import { postDataBrowse } from "@/service/api";
import { getAdmins } from "@/utils/adminDate";
import { setById } from "@/service/base";
export default {
  name: "medicalLog",
  components: {
    medicalForm,
    login,
  },
  data() {
    return {
      man: require("@/assets/medical/male_icon.png"),
      woman: require("@/assets/medical/woman_icon.png"),
      memberId: this.$store.state.memberIdDocument,
      formShow: false,
      searchValue: "",
      minHeight: window.innerHeight - 100 + "px",
      selectedButton: this.$store.state.medicalMenu_log,
      menuVisible: false,
      menuPosition: {
        top: 0,
      },
      selectedIndex: null,
      list: [],
      editForm: {},
      pageNo: 1,
      pageSize: 10,
      activeName: null,
      formulaCode: null,
      detailList: [],
      loading: false,
      finished: false,
      addBtn: false,
      loginShow: false,
      loginTitle: "登录查看更多内容",
    };
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  activated() {
    console.log(this.activeName);
    console.log(this.addBtn);
    console.log(this.formulaCode);
    this.getDetail();
  },
  watch: {
    $route(now) {
      console.log(now);
      this.list = [];
      this.pageNo = 1;
      this.getById();
    },
  },
  created() {
    if (this.$store.state.memberIdDocument == "") {
      // this.loginShow = true;
      this.loginTitle = "登录查看更多内容";
    }
  },
  mounted() {
    this.$store.commit("medicalMenu_typeIndex", 0);
    document.addEventListener("click", this.handleClickOutside);
    this.getList();
    console.log("执行");
  },

  methods: {
    async getById() {
      //像接口头部传用户信息
      let arrays = await getAdmins(
        this.$store.state.memberIdDocument,
        this.$route.query.channel
      );
      await setById(arrays);
      await this.getList();
    },
    handleClickOutside(event) {
      if (event.target.className.includes("van-icon van-icon-ellipsis")) {
        console.log(1);
      } else {
        this.selectedIndex = "随机数";
        this.menuVisible = false;
      }
    },

    maskChineseName(name) {
      // 检查姓名长度
      const length = name.length;

      if (length <= 1) {
        // 如果姓名长度小于等于1，直接返回原名
        return name;
      } else if (length === 2) {
        // 如果姓名长度为2，只替换最后一个字符
        return name[0] + "*";
      } else {
        // 如果姓名长度大于2，替换中间字符
        const firstChar = name[0];
        const lastChar = name[length - 1];
        const middleAsterisks = "*".repeat(length - 2);

        return firstChar + middleAsterisks + lastChar;
      }
    },
    isDate(date) {
      const start = moment()
        .add(-7, "d")
        .format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD") === start ? 0 : 1;
    },

    dateType(date, type) {
      const start = moment()
        .add(-7, "d")
        .format("YYYY-MM-DD");
      return type === 0
        ? moment(date).format("MM月DD日 HH:mm")
        : moment(date).format("YYYY-MM-DD") === start
        ? "近一周无评分记录"
        : moment(date).format("MM月DD日 HH:mm");
    },
    searchOk() {
      this.list = [];
      this.pageNo = 1;
      this.getList();
    },

    async getList() {
      let data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        name: this.searchValue,
      };
      const res =
        this.selectedButton === "left"
          ? await getMedicalLog_time(data)
          : await getMedicalLog_patient(this.searchValue);

      if (res.statuscode === 200) {
        if (this.selectedButton === "left") {
          this.loading = false;
          let item = res.data;
          this.list = this.list.concat(item);
          if (this.list.length >= res.count) {
            this.finished = true;
          }
          if (this.list.length < res.count) {
            this.finished = false;
            this.pageNo += 1;
          }
          // this.activeName = this.list[0].id;
          // this.formulaCode = this.list[0].code;
          // this.getDetail();
        } else {
          this.list = res.data;
        }
      }
    },

    selectButton(button) {
      this.menuVisible = false;
      this.selectedIndex = null;
      this.pageNo = 1;
      this.list = [];
      this.selectedButton = button;
      this.$store.commit("medicalMenu_log", button);
      this.getList();
    },
    toggleMenu(index, event) {
      if (this.selectedIndex === index && this.menuVisible) {
        // 如果当前菜单已经打开，则关闭它
        this.menuVisible = false;
        this.selectedIndex = null;
      } else {
        // 否则，打开菜单并设置位置
        this.selectedIndex = index;
        this.menuVisible = true;
        this.$nextTick(() => {
          const rect = event.target.getBoundingClientRect();
          this.menuPosition.top = rect.bottom + window.scrollY;
        });
      }
    },
    closeMenu() {
      this.menuVisible = false;
      this.selectedIndex = null;
    },
    editItem(index, row) {
      this.editForm = row;
      this.formShow = true;
      this.menuVisible = false;
      this.selectedIndex = null;
    },
    async deleteItem(row) {
      // console.log(row);

      Dialog.confirm({
        title: "是否确认删除？",
        confirmButtonText: "是",
        cancelButtonText: "否",
      })
        .then(async () => {
          const del =
            this.selectedButton === "left"
              ? await delMedicalLog_time(row.id)
              : delMedicalLog_patient(row.id);
          if (del.statuscode === 200) {
            Toast.success("删除成功");
            this.getDetail();
          } else {
            Toast.fail(del.message);
          }

          // on confirm
        })
        .catch(() => {
          // on cancel
        });

      this.menuVisible = false;
      this.selectedIndex = null;
    },
    hideStudent() {
      this.formShow = false;
      this.getList();
    },
    // 跳转回显结果
    logBtn(item) {
      // console.log(item);

      if (this.menuVisible === true) {
        this.menuVisible = false;
        this.selectedIndex = null;
        return;
      }
      this.$router.push({
        path: "/formula/" + this.formulaCode,
        query: {
          logId: item.id,
          id: this.activeName,
          memberId: this.$store.state.memberIdDocument,
          channel: this.$route.query.channel,
          type: "h5",
          location: "YXGS_RECORD_LIST",
        },
      });
      this.addBtn = false;
      // let listScrollTop = document.querySelector(".index").scrollTop;
      // sessionStorage.setItem("scrollTop", listScrollTop);
      // console.log("hhhhhhh",listScrollTop);
      this.addClickRecord(item);
    },
    // 新增跳转
    goNewBtn() {
      if (this.menuVisible === true) {
        this.menuVisible = false;
        this.selectedIndex = null;
        return;
      }
      this.$router.push({
        path: "/formula/" + this.formulaCode,
        query: {
          id: this.activeName,
          memberId: this.$store.state.memberIdDocument,
          channel: this.$route.query.channel,
          type: "h5",
          location: "YXGS_RECORD_ADD_LIST",
        },
      });
      this.addBtn = true;
    },
    goBtn(row) {
      if (this.menuVisible === true) {
        this.menuVisible = false;
        this.selectedIndex = null;
        return;
      }
      row.memberId = this.$store.state.memberIdDocument;
      row.channel = this.$route.query.channel;
      this.$store.commit("editForm", JSON.stringify(row));

      this.$router.push({
        name: "patientLog",
        query: {
          memberId: this.$store.state.memberIdDocument,
          channel: this.$route.query.channel,
        },
      });
    },
    async addClickRecord(item) {
      //像接口头部传用户信息
      let arrays = await getAdmins(
        this.$store.state.memberIdDocument,
        this.$route.query.channel
      );
      //点击埋点
      const data = {
        type: "h5", //index表示在首页列表中点击，mix_index表示在专题列表中点击
        contentId: item.id, //为vod时，根据contentId增加浏览量
        contentType: "YXGS_DWHS",
        location: "YXGS_RECORD_LIST",
        channel: this.$route.query.channel,
        os: arrays.os,
        memberId: this.$store.state.memberIdDocument,
      };
      // console.log(data);
      await postDataBrowse(data);
    },
    change1(id) {
      // console.log("点击");

      // console.log(id);

      this.list.forEach((item) => {
        if (item.id == id) {
          this.formulaCode = item.code;
          this.getDetail();
        }
      });
    },
    async getDetail() {
      let data = {
        pageNo: 1,
        pageSize: 99999,
        formulaCode: this.formulaCode,
      };
      const res = await getGroupRecord(data);
      if (res.code == 0) {
        this.detailList = res.data;
        if (this.detailList.length == 0) {
          this.pageNo = 1;
          this.list = [];
          this.getList();
        }
      }
    },
    login() {
      this.loginShow = true;
    },
  },
  // // 添加这一行 可以保证组件不被keep-alive进行缓存
  deactivated() {
    console.log(this.activeName);

    // console.log("hhhh");

    // this.$destroy();
  },
};
</script>

<style scoped lang="scss">
.DisplayResults {
  margin-top: 5px;
  font-size: 13px;
  color: #2063aa;
  font-weight: 600;
}
.swipe_title_sub {
  margin-top: 5px;
  color: #999999;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}
.card_title {
  display: -webkit-box;
  /* 表示几行后超出隐藏 */
  -webkit-line-clamp: 1;
  /* 超出隐藏 */
  overflow: hidden;
  /*超出显示为省略号*/
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  /*强制英文单词自动换行*/
  word-break: break-all;
}
.swipe_title {
  font-size: 16px;
  display: -webkit-box;
  /* 表示几行后超出隐藏 */
  -webkit-line-clamp: 2;
  /* 超出隐藏 */
  overflow: hidden;
  /*超出显示为省略号*/
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  /*强制英文单词自动换行*/
  word-break: break-all;
  color: black;
}
.index {
  padding-bottom: 100px;
  // background: white;
  height: auto;
  color: #333333;
  font-size: 16px;
  font-weight: 400;
  .card {
    width: 94%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0px;
    border-bottom: #e5e2e2 1px solid;
  }
}
::v-deep .van-search__content {
  background: white !important;
}
.toggle-buttons {
  font-size: 14px;
  display: flex;
  border-radius: 24px 24px 24px 24px;
  border: 1px solid #00bdff;
}

.button {
  flex: 1;
  padding: 3px 10px;
  text-align: center;
  cursor: pointer;
}

.left-button {
  border-radius: 24px 0 0 24px;
}

.right-button {
  border-radius: 0 24px 24px 0;
}

.button.selected {
  background-color: #00bdff;
  color: white;
}

.button:not(.selected) {
  background-color: white;
  color: #00bdff;
}

.left-button.selected {
  border-right: 1px solid #00bdff;
  border-radius: 24px;
}

.right-button.selected {
  border-left: 1px solid #00bdff;
  border-radius: 24px;
}

.popup-menu {
  position: absolute;
  background: white;
  border: 1px solid #f1f1f1;
  padding: 5px 8px;
  right: 2px;
  font-size: 14px;
  z-index: 1000; /* 确保下拉框在最前面 */
}
.list-item {
  position: relative; /* 使下拉框相对于列表项定位 */
  margin-bottom: 20px; /* 添加间距以避免重叠 */
}
.card_man {
  padding: 3px;
  width: 30px;
  height: 30px;
  border: #47a3cc 1px solid;
  border-radius: 6px;
  margin-right: 10px;
}
.card_text {
  font-size: 14px;
  color: #999999;
  .card_name {
    font-size: 15px;
    color: #333333;
  }
}
.dym_collapse {
  ::v-deep .van-cell {
    background-color: rgb(246, 246, 246);
    border-bottom: 0.5px solid rgb(239, 239, 239);
  }
  ::v-deep .van-collapse-item__content {
    background-color: white;
  }
}
.detail {
  font-size: 14px;
  color: black;
  background: white;
  padding: 10px 0px;
}
.detail:not(:last-child) {
  border-bottom: 1px solid #eeeeee;
}
.detail_bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
::v-deep .van-cell__right-icon {
  opacity: 0;
}
.bottom {
  display: inline-block;
  width: 100%;
  height: 100%;
  font-size: 15px;
  line-height: 300px;
  text-align: center;
  color: #00bdff;
}
.bottomhhh {
  width: 70%;
  margin-top:100px;
  margin: 150px auto;
  background-color: rgb(198, 199, 202);
  text-align: center;
  padding: 10px;
  border-radius: 20px;
  color: white;
  font-weight: 550;
  font-size: 20px;
 
}
</style>
